import { BreakpointObserver } from '@angular/cdk/layout';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { BankAccountsService, CreateRulesetRequest, EnrichmentRuleset } from 'src/app/shared/services/bank-accounts.service';

@Component({
  selector: 'app-enrichment-ruleset-list',
  templateUrl: './enrichment-ruleset-list.component.html',
  styleUrls: ['./enrichment-ruleset-list.component.scss']
})
export class EnrichmentRulesetListComponent implements OnInit {

  rulesets: EnrichmentRuleset[] = new Array<EnrichmentRuleset>();
  errorMessage: string = "";
  isLoadingRulesets: boolean = true;
  isDeletingId: string | undefined;
  showEditSidenav: boolean = false;
  addEditIndex: number = -1;
  sideNavMode: string = "";
  addingRulset: boolean = false;
  addRulesetError: string = "";

  rulesetsColumnsDisplay: string[] = ["name", "numberOfRules", "actions"];

  rulesetForm = this.formBuilder.group({
    displayNameCtrl: ['', [Validators.required]]
  });

  constructor(public dialog: MatDialog, private bankAccSvc: BankAccountsService, private activatedRoute: ActivatedRoute, breakpointObserver: BreakpointObserver, private formBuilder: FormBuilder, private _snackBar: MatSnackBar) { }


  ngOnInit(): void {
    this.loadRulesets();
  }

  loadRulesets() {
    this.isLoadingRulesets = true;
    this.bankAccSvc.getEnrichmentRulesets()
      .subscribe({
        next: (data) => {
          this.rulesets = data;
          this.isLoadingRulesets = false;
        },
        error: (err: HttpErrorResponse) => {
          this.isLoadingRulesets = false;
          if (err.status == 404) {
            this.errorMessage = err.error;
          } else {
            throw err;
          }
        }
      })
  }

  openSidenav(mode: string, index: number = -1) {
    this.addEditIndex = index;
    this.sideNavMode = mode;
    this.addingRulset = false;
    this.addRulesetError = "";

    switch (mode) {
      case "addRuleset":
        break;
      case "editRuleset":
        break;
      default:
        break;
    }

    this.showEditSidenav = true;
  }

  closeEditSidenav() {
    this.showEditSidenav = false;
  }

  saveEditSidenav() {
    this.addingRulset = true;
    let addReq = new CreateRulesetRequest();
    addReq.DisplayName = this.rulesetForm.value.displayNameCtrl as string;

    this.bankAccSvc.createRuleset(addReq)
      .subscribe({
        next: (data) => {
          this.loadRulesets();
          this.addingRulset = false;
          this.closeEditSidenav();
        },
        error: (err: HttpErrorResponse) => {
          this.addRulesetError = err.message;
          this.addingRulset = false;
        }
      });
  }

  onDeleteRulesetClick(rulesetId: string) {
    this.isDeletingId = rulesetId;
    let dialogRef = this.dialog.open(DialogDeleteRulesetDialog);

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.bankAccSvc.deleteRuleset(rulesetId).subscribe(
          {
            next: (x) => {
              this.isDeletingId = undefined;
              this.loadRulesets();
            },
            error: (error: HttpErrorResponse) => {
              this.isDeletingId = undefined;
              this._snackBar.open("Error occured deleting your ruleset, please try again later.", undefined, { duration: 5000 })
            },
          }
        );
      }
    });
  }
}


@Component({
  selector: 'enrichment-ruleset-list-delete-dialog',
  templateUrl: 'enrichment-ruleset-list-delete-dialog.component.html',
})
export class DialogDeleteRulesetDialog {
  constructor(public dialogRef: MatDialogRef<DialogDeleteRulesetDialog>) { }
}